import dayjs from 'dayjs';
import type {ForestMassStatus, STATUS} from '@/domain/entities/ForestMassStatus';
import type {ForestMassStatusDto} from './ForestMassStatusDto';

export const toDomain = (dto: ForestMassStatusDto): ForestMassStatus => ({
  ...dto,
  fortopStatus: dto.fortopStatus as STATUS,
  aseforStatus: dto.aseforStatus as STATUS,
  finsaStatus: dto.finsaStatus as STATUS,
  plannedCuttingDate: dayjs(dto.plannedCuttingDate),
  createdAt: dayjs(dto.createdAt),
  finsaStatusChangeDate: dayjs(dto.finsaStatusChangeDate),
  aseforStatusChangeDate: dayjs(dto.aseforStatusChangeDate),
  fortopStatusChangeDate: dayjs(dto.fortopStatusChangeDate),
  uavMetricsStatus: dto.uavMetricsStatus ? (dto.uavMetricsStatus as STATUS) : null,
  uavMetricsStatusChangeDate: dto.uavMetricsStatusChangeDate ? dayjs(dto.uavMetricsStatusChangeDate) : null,
});
